import React from 'react';
import { Col, Form } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import SelectInput from '../SelectInput/SelectInput';

const RegisterFilterSelectorGroup = (props) => {
    return (
        <>
            <div className={'d-flex flex-row'} style={{gap:'16px'}}>
                {props.selectors.map((x,index)=>{
                    if(!x.hasOwnProperty('selectorOptions') || !x.selectorOptions.hasOwnProperty('value') || !x?.selectorOptions?.onChange){
                        throw new Error('Check selectors object in RegisterFilterSelectorGroup ')
                    }
                    return (
                        <div style={{minWidth:x?.minWidth}}>
                                <Form.Group  as={Col} >
                                    <Form.Label>{x.label ?? ''}</Form.Label>
                                        <SelectInput
                                            placeholder={x?.selectorOptions?.placeholder ?? ''}
                                            noOptionsMessage={x?.selectorOptions?.noOptionsMessage ?? (()=> 'Ничего не найдено')}
                                            loadingMessage={x?.selectorOptions?.loadingMessage  ?? (() => 'Поиск...')}
                                            defaultValue={x?.selectorOptions?.defaultValue ?? []}
                                            defaultOptions={x?.selectorOptions?.defaultOptions ?? []}
                                            value={x?.selectorOptions?.value}
                                            onChange={(e)=>x?.selectorOptions?.onChange(e)}
                                        />
                                </Form.Group>
                        </div>)
                })}
            </div>
        </>
    );
};

export default RegisterFilterSelectorGroup;
